(function () {
  const qs = (s, r) => (r || document).querySelector(s);
  const qsa = (s, r) => Array.from((r || document).querySelectorAll(s));

  const toggle = qs("[data-nav-toggle]");
  const nav = qs("[data-nav]");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      nav.classList.toggle("open");
    });
  }

  qsa("[data-main-media]").forEach(function (main) {
    const img = qs("img", main);
    qsa("[data-thumb]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        qsa("[data-thumb]").forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
        if (img && btn.dataset.src) img.src = btn.dataset.src;
      });
    });
  });

  function updateDeal(qty) {
    const deal = qs("[data-deal]");
    if (!deal) return;
    const unit = parseInt(deal.dataset.unit, 10) || 3000;
    const pct = qty >= 3 ? 20 : qty >= 2 ? 10 : 5;
    const total = Math.round((unit * qty * (100 - pct)) / 100);
    const priceEl = qs("[data-deal-price]", deal);
    if (priceEl) priceEl.textContent = money(total);
    qsa("[data-tier]", deal).forEach(function (el) {
      const t = parseInt(el.dataset.tier, 10);
      const on = (qty >= 3 && t === 3) || (qty === 2 && t === 2) || (qty <= 1 && t === 1);
      el.classList.toggle("on", on);
    });
  }

  qsa("[data-qty]").forEach(function (wrap) {
    const input = qs("input", wrap);
    const sync = function () {
      updateDeal(Math.max(1, parseInt(input.value, 10) || 1));
    };
    qsa("button", wrap).forEach(function (btn) {
      btn.addEventListener("click", function () {
        const d = parseInt(btn.dataset.delta, 10);
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + d);
        input.value = next;
        sync();
      });
    });
    input.addEventListener("change", sync);
    input.addEventListener("input", sync);
    sync();
  });

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
    });
  }

  function renderCart(cart) {
    const box = qs("[data-cart-items]");
    const countEls = qsa("[data-cart-count]");
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = "<p>Your cart is currently empty.</p>";
      return;
    }
    box.innerHTML = cart.items.map(function (item) {
      return '<div class="cart-line"><img src="' + esc(item.image || "") + '" alt=""><div><strong>' +
        esc(item.product_title) + '</strong><div class="pdp2-qty" data-cart-qty data-key="' +
        esc(item.key) + '"><button type="button" data-delta="-1" aria-label="Decrease">−</button>' +
        '<input type="number" value="' + item.quantity + '" min="0">' +
        '<button type="button" data-delta="1" aria-label="Increase">+</button></div></div>' +
        '<div class="line-price">' + money(item.final_line_price) + "</div></div>";
    }).join("") + '<p class="cart-foot"><strong>Subtotal ' + money(cart.total_price) +
      '</strong></p><p><a class="btn btn-block" href="/cart">View cart</a></p>';
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error("change"); return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (qs(".cart-page")) window.location.reload();
      });
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-cart-qty] [data-delta]");
    if (!btn) return;
    e.preventDefault();
    const wrap = btn.closest("[data-cart-qty]");
    const input = qs("input", wrap);
    const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.delta, 10));
    input.value = next;
    changeLine(wrap.dataset.key, next);
  });
  document.addEventListener("change", function (e) {
    const input = e.target.closest("[data-cart-qty] input");
    if (!input) return;
    const wrap = input.closest("[data-cart-qty]");
    const next = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = next;
    changeLine(wrap.dataset.key, next);
  });

  const drawer = qs("[data-drawer]");
  qsa("[data-open-cart]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (drawer) drawer.classList.add("open");
      fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart);
    });
  });
  qsa("[data-close-cart]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (drawer) drawer.classList.remove("open");
    });
  });
  if (drawer) {
    drawer.addEventListener("click", function (e) {
      if (e.target === drawer) drawer.classList.remove("open");
    });
  }

  qsa("[data-product-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const data = new FormData(form);
      fetch("/cart/add.js", { method: "POST", body: data })
        .then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
        .then(function () { return fetch("/cart.js"); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          if (drawer) drawer.classList.add("open");
        })
        .catch(function () { form.submit(); });
    });
  });

  const marquee = qs("[data-voices]");
  if (marquee) {
    let dir = 1;
    const prev = qs("[data-voices-prev]");
    const next = qs("[data-voices-next]");
    const setDir = function (nextDir) {
      dir = nextDir;
      marquee.style.animationDirection = dir === 1 ? "normal" : "reverse";
      marquee.style.animationPlayState = "running";
    };
    if (prev) prev.addEventListener("click", function () { setDir(-1); });
    if (next) next.addEventListener("click", function () { setDir(1); });
  }

  const more = qs("[data-more-reviews]");
  if (more) {
    more.addEventListener("click", function () {
      const box = more.closest(".jdgm2");
      if (box) box.classList.add("is-open");
    });
  }

  const speak = qs("[data-speak]");
  if (speak) {
    const items = qsa("[data-speak-item]", speak);
    const viewport = speak.parentElement;
    const prev = qs("[data-speak-prev]");
    const next = qs("[data-speak-next]");
    let i = 0;
    let step = 0;
    let vis = 3;
    const layout = function () {
      vis = window.innerWidth < 900 ? 1 : 3;
      const gap = 18;
      const w = Math.max(160, (viewport.clientWidth - gap * (vis - 1)) / vis);
      items.forEach(function (el) {
        el.style.flex = "0 0 " + w + "px";
        el.style.width = w + "px";
      });
      step = w + gap;
      if (i > Math.max(0, items.length - vis)) i = 0;
      speak.style.transform = "translateX(" + (-i * step) + "px)";
    };
    const go = function (d) {
      const max = Math.max(0, items.length - vis);
      i += d;
      if (i < 0) i = max;
      if (i > max) i = 0;
      speak.style.transform = "translateX(" + (-i * step) + "px)";
    };
    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });
    window.addEventListener("resize", layout);
    layout();
  }
})();
